// Colors constants don't work here
const BOX_SHADOW = {
  DEFAULT: `0 1px 5px 1px rgba(231, 231, 231,1)`,
  HOVER: `0 2px 17px 1px rgba(231, 231, 231,1)`,
  NAVIGATION: `0 2px 11px 3px rgba(68, 68, 68, 0.1)`,
} as const;

export default BOX_SHADOW;
